import type { Cart as SwCart } from '@hubblecommerce/hubble/platforms/shopware/api-client'
import type { HblCart } from '@/utils/types'
import { hblMapLineItems, hblLineItemsIncludes, hblMapTotals, hblTotalsIncludes } from '#imports'

export const hblCartIncludes = {
    'cart': [
        'token',
        'lineItems',
        'price',
        'deliveries',
        'customerComment',
        'errors',
        'extensions',
        'acrisRuleSurchargeDiscountAdditionalCost',
        'nextPromotion',
    ],
    'cart_delivery': [
        'shippingCosts'
    ],
    ...hblLineItemsIncludes,
    ...hblTotalsIncludes,
}

export function hblMapCart (cart: SwCart): HblCart {
    let shippingCosts: any = null
    // @ts-ignore
    if (cart.deliveries.length === 1) {
        // @ts-ignore
        shippingCosts = cart.deliveries[0].shippingCosts.totalPrice
        // @ts-ignore
    } else if (cart.deliveries.length > 1) {
        // @ts-ignore
        shippingCosts = cart.deliveries.map((delivery : any) => delivery.shippingCosts.totalPrice)
    }

    return {
        // @ts-ignore
        id: cart.token,
        // @ts-ignore
        lineItems: hblMapLineItems(cart.lineItems),
        price: hblMapTotals(cart.price),
        // @TODO: Patch api client, add missing deliveries types
        // @ts-ignore
        shippingCosts,
        // @ts-ignore
        surchargeDiscount: cart.extensions?.acrisRuleSurchargeDiscountAdditionalCost,
        comment: cart.customerComment,
        // @ts-ignore
        nextPromotion: cart.extensions?.nextPromotion
    }
}
